var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignInIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.75L10 7.5L13.25 10.75H0.5V13.25H13.25L10 16.5L11.75 18.25L18 12L11.75 5.75ZM23 20.75H13V23.25H23C24.375 23.25 25.5 22.125 25.5 20.75V3.25C25.5 1.875 24.375 0.75 23 0.75H13V3.25H23V20.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInIcon);
export default __webpack_public_path__ + "static/media/sign_in_icon.2267ffc1eaada088cfe6139f8eac94aa.svg";
export { ForwardRef as ReactComponent };